var actions = {
  MyProfile_Login_Widget: {
    onClickForget: 'Click_GoToForgetPass',
    onClickLogin: 'Click_Login',
    onClickRegistration: 'Click_GoToReg',
    onClickSkipSocialLoginFound: 'Click_Skip_SocialFound',
    onClickSocial: 'Click_Login_Social',
    onClickSocialLoginFound: 'Click_Login_SocialFound',
    onOpenSocialLoginFound: 'Open_Login_SocialFound',
    onShowOneTap: 'Onetap_Show',
    onSubmitError: 'Submit Error',
    onSubmitSuccessOnLoginWidget: 'Submit Success',
    onOpen: 'Open'
  },
  'MyProfile Login': {
    onClickForget: 'Click_GoToForgetPass',
    onClickLogin: 'Click_Login',
    onClickRegistration: 'Click_GoToReg',
    onClickSkipSocialLoginFound: 'Click_Skip_SocialFound',
    onClickSocial: 'Click_Login_Social',
    onClickSocialLoginFound: 'Click_Login_SocialFound',
    onShowOneTap: 'Onetap_Show',
    onOpenSocialLoginFound: 'Open_Login_SocialFound',
    onSubmitError: 'Submit Error',
    onSubmitSuccessOnProfile: 'Submit Success'
  }
};
export default actions;